<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Dati Generali" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Tipologia ente</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="tipologiaEnte" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="tipologiaEnteOptions" @change="onChangeTipologiaEnte" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Unità di riferimento</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="unitaRiferimento" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="unitaRiferimentoOptions" @change="onChangeunitaRiferimento" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Codice</label>
                    <b-form-input v-model="jsonData.identificativo" :disabled="true"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <div :class="badgeClass(jsonData.aslAccreditata)" style="margin-top: 27px">
                        <b-form-checkbox v-model="jsonData.aslAccreditata" name="check-button" switch :disabled="tipologiaEnte !== 'ASL'">ASL accreditata</b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Città Capofila</label>
                    <b-form-input v-model="jsonData.cittaCapofila" :disabled="tipologiaEnte !== 'AMBITO'"></b-form-input>
                </b-col>
                <!-- <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Ragione Sociale</label>
                    <b-form-input v-model="jsonData.ragioneSociale"></b-form-input>
                </b-col> -->
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Sigla Fornitore</label>
                    <b-form-input v-model="jsonData.siglaFornitore"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">C.U.U. (IPA)</label>
                    <b-form-input v-model="jsonData.cuuIpa"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Partita IVA</label>
                    <b-form-input v-model="jsonData.partitaIva"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Codice Fiscale</label>
                    <b-form-input v-model="jsonData.codiceFiscale"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Regione</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="regione" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="regione" :options="regioniOptions" @change="onChangeRegione" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Provincia</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="provincia" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="sigla" text-field="provincia" :options="provinciaOptions" @change="onChangeProvincia" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Città</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.cittaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat" text-field="comune" :options="cittaOptions" @change="onChangeCitta" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Indirizzo</label>
                    <b-form-input v-model="jsonData.indirizzo"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">CAP</label>
                    <b-form-input v-model="cap"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Dati Fatturazione" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Natura Fiscale</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.naturaFiscale" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="naturaFiscaleOptions" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Nome Banca</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.nomeBanca" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="bancaOptions" @change="onChangeBanca" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Metodo Pagamento</label>
                    <b-form-input v-model="jsonData.metodoPagamento"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Tipologia Pagamento</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.tipologiaPagamento" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="tipologiaPagamentoOptions" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Giorni Scadenza Fattura</label>
                    <b-form-input v-model="jsonData.giorniScadenzaFattura" type="number" step="1"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Unità di misura:</label>
                    <b-form-input v-model="jsonData.unitaMisura"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Iban</label>
                    <b-form-input v-model="jsonData.iban"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Riferimento Amministrativo</label>
                    <b-form-input v-model="jsonData.riferimentoAmministratore"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Causale</label>
                    <b-form-input v-model="jsonData.codiceCausale"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Regime di ricovero</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.regimeRicovero" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codice" text-field="descrizione" :options="regimiOptions" required></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Presidio</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.codicePresidio" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codicePresidio" text-field="denominazionePresidio" :options="presidiOptions" required></b-form-select>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Configurazione Fattura" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="badgeClass(jsonData.fatturaNovantacinquePercento)">
                        <b-form-checkbox v-model="jsonData.fatturaNovantacinquePercento" name="check-button" switch>Fattura 95%</b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="badgeClass(jsonData.impostaBollo)">
                        <b-form-checkbox v-model="jsonData.impostaBollo" name="check-button" switch>Imposta di bollo</b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="badgeClass(jsonData.riepilogoTrattamentiErogati)">
                        <b-form-checkbox v-model="jsonData.riepilogoTrattamentiErogati" name="check-button" switch>Riepilogo trattamenti erogati</b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="badgeClass(jsonData.raggruppaDistretto)">
                        <b-form-checkbox v-model="jsonData.raggruppaDistretto" name="check-button" switch>Raggruppamento per distretto</b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="badgeClass(jsonData.descrizionePrestazione)">
                        <b-form-checkbox v-model="jsonData.descrizionePrestazione" name="check-button" switch>Descrizione delle prestazioni</b-form-checkbox>
                    </div>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <div :class="badgeClass(jsonData.fatturaSingoloPaziente)">
                        <b-form-checkbox v-model="jsonData.fatturaSingoloPaziente" name="check-button" switch>Fattura per singolo paziente</b-form-checkbox>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import PresidiMixin from "../../strutture/mixins/PresidiMixin";
export default {
    components: {},
    mixins: [UtilityMixin, PresidiMixin],
    data() {
        return {
            pathResource: "/flussidatifatturazione",
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            pathResourceRegioni: "/regioni",
            pathResourceComune: "/comuni/istat",
            pathResourceStrutturaIban: "/struttureiban",
            pathResourceServiziAsl: "/asl",
            pathResourceServiziAmbiti: "/serviziambiti",
            pathResourceAccettazioniRegimi: "/accettazioneregimi",
            id: "-1",
            isDomiciliare: false,
            tipologia: "",
            regione: null,
            cap: "",
            provincia: null,
            tipologiaEnte: null,
            unitaRiferimento: null,
            jsonData: {
                aslAccreditata: null,
                cittaCapofila: null,
                cittaCodiceIstat: null,
                codiceCausale: null,
                codiceFiscale: null,
                codicePresidio: null,
                cuuIpa: null,
                descrizioneCausale: null,
                descrizionePrestazione: null,
                fatturaNovantacinquePercento: null,
                fatturaSingoloPaziente: null,
                giorniScadenzaFattura: null,
                iban: null,
                identificativo: null,
                impostaBollo: null,
                indirizzo: null,
                metodoPagamento: null,
                naturaFiscale: null,
                nomeBanca: null,
                partitaIva: null,
                proprietario: null,
                raggruppaComune: null,
                raggruppaDistretto: null,
                ragioneSociale: null,
                regimeRicovero: null,
                riepilogoTrattamentiErogati: null,
                riferimentoAmministratore: null,
                siglaFornitore: null,
                tipologia: null,
                tipologiaPagamento: null,
                unitaMisura: null,
            },
            regioniOptions: [],
            provinciaOptions: [{ sigla: null, provincia: "-Seleziona Provincia-" }],
            cittaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            regimiOptions: [],
            tipologiaPagamentoOptions: [
                { text: "- Seleziona Valore -", value: null },
                { text: "PAGAMENTO A RATE", value: "PAGAMENTO A RATE" },
                { text: "PGAMENTO COMPLETO", value: "PAGAMENTO COMPLETO" },
                { text: "ANTICIPO", value: "ANTICIPO" },
            ],
            naturaFiscaleOptions: [
                { text: "- Seleziona Valore -", value: null },
                { text: "N1", value: "N1" },
                { text: "N4", value: "N4" },
            ],
            bancaOptions: [{ text: "- Seleziona Valore -", value: null }],
            tipologiaEnteOptions: [
                { text: "- Seleziona Valore -", value: null },
                { text: "ASL", value: "ASL" },
                { text: "AMBITO", value: "AMBITO" },
                { text: "PAZIENTE", value: "PAZIENTE" },
            ],
            unitaRiferimentoOptions: [{ text: "- Seleziona Valore -", value: null }],
            ambiti: [],
            asl: [],
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    computed: {},
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadRegioni();
        me.loadStrutturaIban();
        me.loadRegimi();
        me.loadData();
        me.loadUtentePresidio();
    },
    methods: {
        badgeClass(selected) {
            return selected ? "sa-badge sa-badge-selected" : "sa-badge";
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = {};
                        me.jsonData = response.data.data;
                        me.tipologiaEnte = me.jsonData.tipologia;
                        me.onChangeTipologiaEnte(me.tipologiaEnte);
                        if (me.jsonData.cittaCodiceIstat) {
                            me.loadCittaByCodiceIstat(me.jsonData.cittaCodiceIstat);
                        }
                        this.$emit("afterLoadData");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onChangeRegione(regione) {
            let me = this;
            me.provincia = null;
            me.provinciaOptions = [];
            me.provinciaOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
            me.loadProvince(regione);
        },
        onChangeProvincia(provincia) {
            let me = this;
            me.jsonData.cittaCodiceIstat = null;
            me.cittaOptions = [];
            me.cittaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(provincia);
        },
        onChangeCitta(value) {
            let me = this;
            me.loadCap(value);
        },
        loadRegioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegioni;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((regione) => {
                        me.regioniOptions.push(regione);
                    });
                    me.regioniOptions.unshift({ codiceIstat: null, regione: "-Seleziona Regione-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadProvince(regione) {
            let me = this;
            me.filtro = { regione: regione };
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios.get(link, { params: me.filtro }).then((response) => {
                response.data.data.forEach((provincia) => {
                    me.provinciaOptions.push(provincia);
                });
            });
        },
        loadComuni(sigla) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuni + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        me.cittaOptions.push(comune);
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadCap(codiceIstat) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComune + "/" + codiceIstat;
            if (codiceIstat) {
                axios
                    .get(link)
                    .then((response) => {
                        me.cap = response.data.data.cap;
                    })
                    .catch((error) => {
                        console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                    });
            }
        },
        onChangeTipologiaEnte(value) {
            let me = this;
            switch (value) {
                case "ASL":
                    me.loadServiziAsl();
                    me.jsonData.cittaCapofila = null;
                    break;
                case "AMBITO":
                    me.loadServiziAmbiti();
                    me.jsonData.aslAccreditata = false;
                    break;
                case "PAZIENTE":
                    me.loadDatiFatturazioneUtente();
                    me.jsonData.aslAccreditata = false;
                    me.jsonData.cittaCapofila = null;
                    break;

                default:
                    break;
            }
        },
        onChangeunitaRiferimento() {
            let me = this;
            switch (me.tipologiaEnte) {
                case "ASL":
                    me.asl.forEach((element) => {
                        if (element.denominazione === me.unitaRiferimento) {
                            me.jsonData.ragioneSociale = element.denominazione;
                            me.jsonData.identificativo = element.codiceRegione + element.codiceAzienda;
                        }
                        me.jsonData.tipologia = "ASL";
                    });
                    break;
                case "AMBITO":
                    me.ambiti.forEach((element) => {
                        if (element.id === me.unitaRiferimento) {
                            me.jsonData.ragioneSociale = element.description;
                            me.jsonData.riferimentoAmministratore = element.administrationReference;
                            me.jsonData.impostaBollo = element.billTax;
                            me.jsonData.codiceCausale = element.causal;
                            me.jsonData.codiceFiscale = element.fiscalCode;
                            me.jsonData.cuuIpa = element.cuuIpa;
                            me.jsonData.partitaIva = element.piva;
                            me.jsonData.identificativo = element.areaCode;
                        }
                        me.jsonData.tipologia = "AMBITO";
                    });
                    break;
                case "PAZIENTE":
                    me.jsonData.tipologia = "PAZIENTE";
                    break;

                default:
                    break;
            }
        },
        loadStrutturaIban() {
            let me = this;
            if (localStorage.getItem("presidio")) {
                let presidioUtente = JSON.parse(localStorage.getItem("presidio"));
                me.loadDataResources(me.pathResourceStrutturaIban, { idStruttura: presidioUtente.idStruttura }, me.resultResponseStrutturaIban, me.resultErrorStrutturaIban);
            } else {
                this.$bvToast.toast("Errore nel recupero del Presidio", {
                    title: "Attenzione",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        resultResponseStrutturaIban(response) {
            let me = this;
            me.bancaOptions = [];
            me.banche = response.data.data.list;
            response.data.data.list.forEach((element) => {
                me.bancaOptions.push({ value: element.banca, text: element.banca });
            });
            me.bancaOptions.unshift({ text: "- Seleziona Valore -", value: null });
        },
        resultErrorStrutturaIban(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore caricamento Strutture Iban";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        onChangeBanca(value) {
            let me = this;
            me.banche.forEach((element) => {
                if (element.banca === value) {
                    me.jsonData.iban = element.iban;
                }
            });
        },
        loadServiziAsl() {
            let me = this;
            me.loadDataResources(me.pathResourceServiziAsl, {}, me.resultResponseAsl, me.resultErrorAsl);
        },
        resultResponseAsl(response) {
            let me = this;
            me.asl = [];
            me.unitaRiferimentoOptions = [];
            me.asl = response.data.data;
            me.asl.forEach((element) => {
                me.unitaRiferimentoOptions.push({ text: element.denominazione, value: element.denominazione });
            });
            me.unitaRiferimentoOptions.unshift({ text: "- Seleziona Valore -", value: null });
            if (me.id !== "-1") {
                me.unitaRiferimento = me.jsonData.ragioneSociale;
            }
        },
        resultErrorAsl(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore caricamento delle ASL";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        loadServiziAmbiti() {
            let me = this;
            me.loadDataResources(me.pathResourceServiziAmbiti, {}, me.resultResponseServiziAmbiti, me.resultErrorServiziAmbiti);
        },
        resultResponseServiziAmbiti(response) {
            let me = this;
            me.unitaRiferimentoOptions = [];
            me.ambiti = response.data.data.list;
            me.ambiti.forEach((element) => {
                me.unitaRiferimentoOptions.push({ text: element.description + " - " + element.areaCode, value: element.id });
                if (me.id !== "-1") {
                    if (element.description === me.jsonData.ragioneSociale) {
                        me.unitaRiferimento = element.id;
                    }
                }
            });
            me.unitaRiferimentoOptions.unshift({ text: "- Seleziona Valore -", value: null });
        },
        resultErrorServiziAmbiti(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore caricamento Ambiti";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        loadDatiFatturazioneUtente() {
            let me = this;
            me.loadDataResources(me.pathResource, { tipologia: "PAZIENTE" }, me.resultResponseFatturazioneUtente, me.resultErrorFatturazioneUtente);
        },
        resultResponseFatturazioneUtente(response) {
            let me = this;
            if (response.data.data.list.length > 0) {
                me.jsonData = response.data.data.list[0];
            }
        },
        resultErrorFatturazioneUtente(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore caricamento Utente Fatturazione";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        loadCittaByCodiceIstat(codiceIstat) {
            let me = this;
            me.loadDataResources(me.pathResourceComune + "/" + codiceIstat, {}, me.resultResponseCittaByCodiceIstat, me.resultErrorCittaByCodiceIstat);
        },
        resultResponseCittaByCodiceIstat(response) {
            let me = this;
            let comune = response.data.data;
            me.cap = comune.cap;
            me.cittaOptions.push(comune);
        },
        resultErrorCittaByCodiceIstat(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messagio : "Errore nel caricamento del comune ";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        loadRegimi() {
            let me = this;
            me.loadDataResources(me.pathResourceAccettazioniRegimi, {}, me.resultResponseRegimi, me.resultErrorRegimi);
        },
        resultResponseRegimi(response) {
            let me = this;
            me.regimiOptions = [];
            me.regimiOptions = response.data.data.list;
            me.regimiOptions.unshift({ descrizione: "- Seleziona Valore -", codice: null });
        },
        resultErrorRegimi(error) {
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore caricamento Regimi Ricovero";
            this.$bvToast.toast(messaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
        },
        loadUtentePresidio() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage.getItem("user")) {
                let user = JSON.parse(sessionStorage.getItem("user"));
                me.loadPresidiUtente(user.id, me.loadPresidiUtenteSuccess);
            }
        },
        loadPresidiUtenteSuccess() {
            let me = this;
            me.presidiOptions.unshift({ denominazionePresidio: "- Seleziona Valore -", codicePresidio: null });
        },
    },
};
</script>
<style></style>
